
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../../common/client/components/Text';

import { getOpsubAddress, getOpsubName } from '../../../reducers/opsub';

import IfComp from '../IfComp';
import LinkToOpsub from './LinkToOpsub';
import ListInfoLoading from './ListInfoLoading';
import ListInfoNoData from './ListInfoNoData';

const classNames = mergeStyleSets({
    row: {
        paddingLeft: 0,
    },
    rowCompact: {
        paddingLeft: 0,
    },
    opsubClick: {
        '&:hover': {
            backgroundColor: '#dddddd',
            cursor: 'pointer'
        }
    },
    opsubTitle: {
        paddingLeft: 0,
        paddingBottom: 4
    },
    opsubAddress: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 250
    },
    opsubName: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 250
    },
    opsubType: {
        width: 40
    },
    opsubContainer: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 0
    },
    opsubContainerCompact: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 0
    }
});

const IsknOpsubTitle = () => {
    return (
        <Stack horizontal verticalAlign="end" className={classNames.parTitle}>
            <Text bold className={classNames.opsubName}>Jméno / Název</Text>
            <Text bold className={classNames.opsubAddress}>Adresa</Text>
            <Text bold className={classNames.opsubType}>Typ</Text>
        </Stack>
    );
}

const IsknOpsubItem = ({compact, isknDate, opsubItem, onClick}) => {

    const opsubName = getOpsubName(opsubItem);
    const opsubAddress = getOpsubAddress(opsubItem);

    const handleClick = () => {
        if (onClick) {
            onClick(opsubItem.opsub_id);
        }
    }

    let classNamesArr = [compact ? classNames.rowCompact : classNames.row];
    if (onClick) {
        classNamesArr.push(classNames.opsubClick)
    }

    return (
        <Stack horizontal verticalAlign="end" className={classNamesArr.join(' ')} onClick={handleClick}>
            <IfComp cond={compact}>
                <Stack.Item>
                    <LinkToOpsub isknDate={isknDate} opsub={opsubItem} />
                </Stack.Item>
            </IfComp>
            <IfComp cond={!compact}>
                <Text className={classNames.opsubName}>{opsubName}</Text>
                <Text className={classNames.opsubAddress}>{opsubAddress}</Text>
                <Text className={classNames.opsubType}>{opsubItem.opsub_type}</Text>
            </IfComp>
        </Stack>
    );
}

const IsknOpsubList = ({compact, isknDate, data, loading, onClick}) => {

    return (
        <Stack className={compact ? classNames.opsubContainerCompact : classNames.opsubContainer}>
            <IfComp cond={!compact && (data.opsub.length > 0)}>
                <IsknOpsubTitle />
            </IfComp>
            {data.opsub.map(item => {
                return (
                    <IsknOpsubItem
                        key={item.opsub_id}
                        compact={compact}
                        isknDate={isknDate}
                        opsubItem={item}
                        onClick={onClick}
                    />
                );
            })}
            <IfComp cond={loading}>
                <ListInfoLoading />
            </IfComp>
            <IfComp cond={(data.opsub.length === 0) && !loading}>
                <ListInfoNoData />
            </IfComp>
        </Stack>
    );
}

export default IsknOpsubList;
